import { useState , useEffect} from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import Header from './components/Header'
import Tasks from './components/Tasks'
import AddTask from './components/AddTask'
import Footer from './components/Footer'
import About from './components/About'

const App = () => {
  const [showAddTask, setShowAddTask] =useState(false)
  const [tasks, setTasks] = useState([])

  useEffect(() => {
    const getTasks = async () => {
      const tasksFromServer = await fetchTasks()
      setTasks(tasksFromServer)
    }

    getTasks()
    
},[])

//Fetch Tasks
  const fetchTasks = async () => {
    console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
    const res = await fetch('http://localhost:8080/tasks');
    const data = await res.json();

    return data
  }


//Fetch Task
const fetchTask = async (id) => {
  const res = await fetch(`http://localhost:8080/tasks/${id}`);

  const data = await res.json()

  return data
}
  //Add Task
  const addTask =async (task) => {
    const res = await fetch('http://localhost:8080/tasks', {
      method: 'POST',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify(task)
    })

    const data= await res.json()

    setTasks([...tasks,data])
    // console.log(task);
    // const id = Math.floor(Math.random()*10000)+1
    // const newTask = {id,...task}
    // setTasks([...tasks,newTask])
  }

  //Delete Task
  const deleteTask = async (id) => {
    await fetch(`http://localhost:8080/tasks/${id}`,{
      method:'DELETE',mode:'cors'
    })
    // console.log('Delete' ,id)
    setTasks(tasks.filter((task) => task.id !==id))
  }

  //Toggle Reminder
  const toggleReminder = async (id) => {
    // console.log(id)
    const taskToToggle = await fetchTask(id)
    const updTask = {...taskToToggle,
    reminder: !taskToToggle.reminder}

    const res = await fetch(`http://localhost:8080/tasks/${id}`,
      {
        method:'PUT',
        headers: {
          'Content-type': 'application/json'
        },
        body: JSON.stringify(updTask)
      }
    )

    const data = await res.json()
    setTasks(
      tasks.map((task) => 
        task.id ===id ? {...task,reminder:
        data.reminder } :task
      )
    )
  }

  return (
    <Router>
    <div className="container">
      <Header 
        onAdd={() => setShowAddTask
        (!showAddTask)}
        showAdd={showAddTask}
      />
      {showAddTask && <AddTask onAdd={addTask} />}
      {tasks.length >0 ? (
        <Tasks 
          tasks = {tasks} 
          onDelete= {deleteTask}
          onToggle={toggleReminder}
        />
      ) : (
      'No Tasks To Show'
      )}
      <Route path='/about' component= {About}/>
      <Footer />
    </div>
    </Router>
  );
}

export default App;

